<div class="decisions">
  <header class="decisions__header">
    <h3 class="decisions__title">{{ 'usage.decisions.title' | translate }}</h3>
    <span class="decisions__count" *ngIf="!isEmpty">{{ sortedDecisions.length }}</span>
  </header>

  <p class="decisions__empty" *ngIf="isEmpty">
    {{ 'usage.decisions.empty' | translate }}
  </p>

  <div class="decisions__table-wrapper" *ngIf="!isEmpty">
    <table class="decisions__table">
      <thead>
        <tr>
          <th scope="col">{{ 'usage.decisions.col.timestamp' | translate }}</th>
          <th scope="col">{{ 'usage.decisions.col.module' | translate }}</th>
          <th scope="col">{{ 'usage.decisions.col.operation' | translate }}</th>
          <th scope="col">{{ 'usage.decisions.col.limit' | translate }}</th>
          <th scope="col">{{ 'usage.decisions.col.decision' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of pageItems">
          <td [attr.data-label]="'usage.decisions.col.timestamp' | translate">{{ row.createdAt | date:'short' }}</td>
          <td [attr.data-label]="'usage.decisions.col.module' | translate">{{ row.sourceModule }}</td>
          <td [attr.data-label]="'usage.decisions.col.operation' | translate">{{ row.operation }}</td>
          <td [attr.data-label]="'usage.decisions.col.limit' | translate">{{ row.limitCode | limitLabel }}</td>
          <td [attr.data-label]="'usage.decisions.col.decision' | translate">
            <span class="badge"
                  [class.badge--ok]="row.allowed"
                  [class.badge--blocked]="!row.allowed">
              {{ (row.allowed ? 'usage.decisions.allowed' : 'usage.decisions.blocked') | translate }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav class="decisions__pager" *ngIf="totalPages > 1" [attr.aria-label]="'usage.decisions.pager' | translate">
    <button type="button" class="decisions__pager-btn" (click)="prev()" [disabled]="page === 0">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
    </button>
    <span class="decisions__pager-status">{{ page + 1 }} / {{ totalPages }}</span>
    <button type="button" class="decisions__pager-btn" (click)="next()" [disabled]="page >= totalPages - 1">
      <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </button>
  </nav>
</div>
